(() => {
  // If Dawn's custom element is present, do nothing.
  // Comment this guard out if you want to force the patch.
  if (customElements.get('variant-radios')) return;

  const parseVariants = (root) => {
    const json = root.querySelector('script[type="application/json"]');
    if (!json) return null;
    try { return JSON.parse(json.textContent); } catch { return null; }
  };

  const getSelectedOptions = (root) => {
    const fieldsets = root.querySelectorAll('fieldset.product-form__input');
    const selected = [];
    fieldsets.forEach((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) selected.push(checked.value);
      else {
        const sel = fs.querySelector('select');
        if (sel) selected.push(sel.value);
      }
    });
    return selected;
  };

  const findVariant = (variants, selected) => {
    return variants?.find(v => Array.isArray(v.options) && v.options.join('||') === selected.join('||'));
  };

  const updateHiddenId = (root, variantId, eventTarget) => {
    // Use the form attribute already on inputs
    const formId = eventTarget?.getAttribute?.('form');
    const form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    let idInput = form.querySelector('input[name="id"]');
    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      form.appendChild(idInput);
    }
    idInput.value = String(variantId);
  };

  const updateUrl = (root, variantId) => {
    if (root.getAttribute('data-update-url') === 'false') return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  };

  const boot = () => {
    document.querySelectorAll('variant-radios, variant-selects').forEach((root) => {
      if (root.__variantPatchBound) return;
      root.__variantPatchBound = true;

      const variants = parseVariants(root);
      if (!variants) return;

      root.addEventListener('change', (e) => {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;

        // Work only when an option control changes
        if (!target.matches('input[type="radio"], select')) return;

        const selected = getSelectedOptions(root);
        const variant = findVariant(variants, selected);
        if (!variant) return;

        updateHiddenId(root, variant.id, target);
        updateUrl(root, variant.id);

        // If your "Colour: X" heading exists, update it
        const fs = target.closest('fieldset');
        const out = fs && fs.querySelector('[data-swatch-selected]');
        if (out && target instanceof HTMLInputElement) out.textContent = target.value;

        // Trigger Dawn's product-info update if product-info exists
        root.dispatchEvent(new CustomEvent('optionValueSelectionChange', {
          bubbles: true,
          detail: { event: e, target }
        }));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
